import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    dialogContent: {
        maxWidth: 1100,
        width: "100%",
        paddingBottom: 0,
    },
    dialogTitleContainer: {
        display: "flex",
        justifyContent: "space-between",
    },

    dialog: {
        maxWidth: "1200px",
    },
    loaderContainer: {
        width: 300,
        height: 300,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    loaderContainerAdvanced: {
        width: 300,
        height: 300,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 auto",
    },
    contentBox: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minWidth: 300,
    },
    modeContainer: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        paddingRight: theme.spacing(2),
    },
    dataContainer: {
        display: "flex",
        justifyContent: "space-between",
        gap: theme.spacing(5),
        width: "100%",
        flexWrap: "wrap",
    },

    input: {
        marginBottom: theme.spacing(2),
    },
}));
